import type { BlockSeason } from "../../api/types";

// SeasonPicker is the leadership-only season dropdown over useBlockSeason's
// seasons. Everyone else gets no seasons from the hook — rank-and-file only
// ever see the active season — so it renders nothing for them.
export function SeasonPicker({
  seasons,
  value,
  onChange
}: {
  seasons: BlockSeason[];
  value: string;
  onChange: (seasonID: string) => void;
}) {
  if (seasons.length === 0) {
    return null;
  }

  return (
    <label>
      Season
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {seasons.map((season) => (
          <option key={season.id} value={season.id}>
            {seasonPickerLabel(season)}
          </option>
        ))}
      </select>
    </label>
  );
}

function seasonPickerLabel(season: BlockSeason): string {
  const status = season.status === "draft" ? "Planning" : season.status;
  return `${season.name} · ${status}`;
}
